export const redirectToRootAddress = () => {
  const url = window.location.href;
  localStorage.setItem('lastLocation', url);
  const arr = url.split('/');
  window.location.href = `${arr[0]}//${arr[2]}`;
};
